import { useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { professionalHasP2PPermission } from '@/utils/professionalPermissionTags';
import { ProfessionalPatientsManager } from './components/ProfessionalPatientsManager';

type ProfessionalLayoutContext = {
	data: Professionals.Professional | undefined;
	isLoading: boolean;
};

const ProfessionalPatients = () => {
	const navigate = useNavigate();
	const { data: professional, isLoading: isProfessionalLoading } =
		useOutletContext<ProfessionalLayoutContext>();

	const canManagePatients = professionalHasP2PPermission(professional);

	useEffect(() => {
		if (isProfessionalLoading) return;
		if (!canManagePatients) {
			navigate('/profissional/home', { replace: true });
		}
	}, [isProfessionalLoading, canManagePatients, navigate]);

	if (isProfessionalLoading || !canManagePatients) {
		return null;
	}

	return (
		<ProfessionalPatientsManager
			professional={professional}
			listTitle="Seus pacientes"
			subpageHeaderTitle="Seus pacientes"
			subpageHeaderBreadcrumb={['PACIENTES', 'LISTA']}
			onBack={() => navigate('/profissional/home')}
			showScheduleAction
			showProntuarioAction
			enabled={canManagePatients}
		/>
	);
};

export { ProfessionalPatients };
